import {
  TextMatchTransformer,
  Transformer,
  TRANSFORMERS
} from '@lexical/markdown';

import { ID } from '../../../../types';

import {
  $createMentionNode,
  $isMentionNode,
  MentionNode
} from '../MentionNode';

export const MENTION_HREF_PREFIX = '#mention-';

// Matches mention markers in message markdown, e.g. [@John Smith](#mention-123)
export const MENTION_MARKDOWN_IMPORT_REGEXP =
  /\[(@[^\]]+)\]\(#mention-([\w-]+)\)/;

const MENTION_MARKDOWN_REGEXP = /\[(@[^\]]+)\]\(#mention-([\w-]+)\)$/;

const MENTION_MARKDOWN_GLOBAL_REGEXP = /\[(@[^\]]+)\]\(#mention-([\w-]+)\)/g;

export const MENTION_MARKDOWN_TRANSFORMER: TextMatchTransformer = {
  dependencies: [MentionNode],
  export: (node) => {
    if (!$isMentionNode(node)) {
      return null;
    }

    return `[${node.getTextContent()}](${MENTION_HREF_PREFIX}${node.__id})`;
  },
  importRegExp: MENTION_MARKDOWN_IMPORT_REGEXP,
  regExp: MENTION_MARKDOWN_REGEXP,
  replace: (textNode, match) => {
    const [, mentionName, mentionId] = match;
    textNode.replace($createMentionNode(mentionId, mentionName));
  },
  trigger: ')',
  type: 'text-match'
};

// Mention transformer goes first so mention markers are consumed
// before the generic LINK transformer can match them
export const LEXICAL_EDITOR_TRANSFORMERS: Transformer[] = [
  MENTION_MARKDOWN_TRANSFORMER,
  ...TRANSFORMERS
];

export function getMentionIdsFromMarkdown(markdown?: string): ID[] {
  if (!markdown) {
    return [];
  }

  return [...markdown.matchAll(MENTION_MARKDOWN_GLOBAL_REGEXP)].map(
    (match) => match[2]
  );
}

export default MENTION_MARKDOWN_TRANSFORMER;
